<template>
    <div class="infoengine">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-6">
                    <h2 class="filter-heading">Name Screening Score Factors</h2>
                </div>
            </div>
        </div>
        <div
            :class="[
                'table-section',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table :items="data" :fields="fields">
                <template slot="action" slot-scope="data">
                    <div class="action-review">
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('modify-score-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>
        <modify-score-popup></modify-score-popup>
        <base-records
            path="configurations/name-screening-scores"
            :query="query"
            :reset="reset"
            :show-pagination="false"
        ></base-records>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import modifyScorePopup from '@/components/popups/ModifyScorePopup.vue'
export default {
    components: {
        modifyScorePopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            fields: [
                {
                    key: 'code',
                    label: 'Code',
                    class: 'w-320px',
                    sortable: true,
                },
                {
                    key: 'factor',
                    label: 'Screening Factor',
                    class: 'w-320px',
                    sortable: true,
                    // formatter: (value) => {
                    //     return _.startCase(value)
                    // },
                },
                {
                    key: 'score',
                    label: 'Score',
                    class: 'text-center',
                    sortable: true,
                },
                {
                    key: 'action',
                    label: 'ACTION',
                    class: 'single-list',
                },
            ],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 100,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'code',
                sortOrder: 'asc',
            },
            reset: new Date().getTime(),
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data', 'showPageLoader', 'loading']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
        }, // End of sortingChanged() method
    }, // End of Component > mounted
} // End of export default
</script>
